import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=efe9d588&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"
import style0 from "./Loading.vue?vue&type=style&index=0&id=efe9d588&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe9d588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efe9d588')) {
      api.createRecord('efe9d588', component.options)
    } else {
      api.reload('efe9d588', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=efe9d588&scoped=true", function () {
      api.rerender('efe9d588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Loading.vue"
export default component.exports